import { object, string } from 'yup';

export const initialValues = {
  txHash: '',
};

export const validationSchema = object().shape({
  resourceId: string().notRequired(),
});
